export const aciDisney = {
    iconName: 'disney',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M18.735 2.5c-2.203 0-4.147 1.685-4.536 3.888.389.13.907.259 1.296.388.13-1.684 1.555-2.98 3.24-2.98 1.814 0 3.369 1.555 3.369 3.499 0 1.684-1.296 3.24-2.85 3.498.129.39.258.908.388 1.296 2.203-.518 3.758-2.462 3.758-4.794 0-2.592-2.073-4.795-4.665-4.795zM5.556 10.78s.881.118 1.01.51c.118.274-.012.927-.012.927-.389.13-1.166 0-1.296-.13.13-.523.298-1.306.298-1.306z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M14.2 7.683c.129 0 .777.26 1.036 0 .26-.259.26-.518.26-.907-.26-.259-1.297-.389-1.297-.389v1.296zM19.383 10.793c-.26 0-.778 0-.907.389-.13.26-.13.648 0 1.037.389.13 1.296 0 1.296 0s-.13-1.167-.389-1.426zM5.647 10.793c-1.555-.259-2.851-1.684-2.851-3.498 0-1.944 1.555-3.5 3.37-3.5 1.684 0 3.11 1.297 3.368 2.981.39-.259.778-.388 1.167-.388C10.31 4.185 8.368 2.5 6.165 2.5 3.573 2.5 1.5 4.703 1.5 7.295c0 2.332 1.555 4.276 3.758 4.794.13-.518.26-.907.389-1.296z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M10.83 7.295v.389s1.037-.26 1.685-.26c.648 0 1.684.26 1.684.26v-.389c0-.389 0-.648.13-1.037 0 0-1.166-.13-1.814-.13-.648 0-1.944.26-1.815.26.13.26.13.648.13.907zM19.771 12.09c-.26.13-.648.13-.907.13h-.389c.13.647.26 1.295.26 1.943 0 3.629-2.851 6.61-6.22 6.61-3.37 0-6.22-2.981-6.22-6.61 0-.648.129-1.296.258-1.944h-.388c-.39 0-.648 0-.908-.13-.13.649-.259 1.297-.259 1.945 0 4.406 3.37 7.904 7.516 7.904 4.147 0 7.516-3.498 7.516-7.904 0-.648-.13-1.296-.259-1.944z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M10.83 7.685c-.259.13-.8.239-1.036 0-.158-.16-.26-.262-.26-.917.26-.262.908-.393 1.167-.393.26.262.26.917.13 1.31z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
